fx.ns("models", class ThemeBackgroundTag extends fx.Model {

	constructor(data)
	{
		super(data);
	}

});